import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { faturaMixin } from '@/modules/faturas/mixins'

export default {
  name: 'FormularioCredito',
  components: {
    spinnerProcessando
  },
  mixins: [faturaMixin],
  model: {
    prop: 'cartao',
    event: 'update'
  },
  props: {
    listaDeErros: {
      type: [Array, Object],
      required: false,
      default: () => {}
    },
    cartao: {
      type: Object,
      required: true
    },
    flagsDeControle: {
      type: Object,
      required: true
    }

  },
  computed: {
    formulario: {
      get () {
        return this.cartao
      },
      set (novoValor) {
        this.$emit('input', novoValor)
      }
    },
    desabilitarCampos () {
      return this.flagsDeControle.manipulandoDados.status || this.flagsDeControle.carregandoDados.status
    }
  },

  data: () => {
    return {
    }
  },
  async mounted () {
  },
  methods: {
    obterBandeiraInputLocal (bandeira) {
      return this.obterIconeBandeira(bandeira)
    },
    determinarBandeiraDoCartao (event) {
      const numero = event.target.value.trim().replace(/\s+/g, '')
      const filtroPorNumeroCartao = (numero, bandeira) => bandeira.regex.test(numero)
      const bandeiraEncontrada = this.obterBandeiraCartaoPorFiltro(numero, filtroPorNumeroCartao)
      this.formulario.bandeira = bandeiraEncontrada?.nome
    }
  }
}
